var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{ref:"table",tag:"component",class:{ 'no-print': _vm.isQuickPrint }})}
var staticRenderFns = []

export { render, staticRenderFns }